
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 249.88 235.8"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('linearGradient',{attrs:{"id":"linear-gradient","x1":"38.5","y1":"171.79","x2":"178.01","y2":"122.94","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#ffc24e"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#ffbb38"}})])]),_c('path',{attrs:{"d":"M190.75 180.66h-80.52a5.31 5.31 0 00-2.36.55l-27 13.44-.35.16c-12.52 5.25-12.37-3.21-12.4-6.21-.08-11 0 0-.08-16.87V86.4a14.28 14.28 0 0114.24-14.24h108.47A14.28 14.28 0 01205 86.4v80a14.28 14.28 0 01-14.25 14.26z","fill":"#fca737"}}),_c('path',{attrs:{"d":"M163.56 201.24H83a5.31 5.31 0 00-2.36.55l-27 13.44-.35.16c-12.43 5.25-12.33-3.21-12.35-6.22-.08-11 0 0-.08-16.87V107a14.28 14.28 0 0114.22-14.25h108.48A14.28 14.28 0 01177.79 107v80a14.28 14.28 0 01-14.23 14.24z","fill":"url(#linear-gradient)"}}),_c('circle',{staticClass:"cls-3",attrs:{"cx":"83.01","cy":"143.39","r":"9.06"}}),_c('circle',{staticClass:"cls-3",attrs:{"cx":"142.51","cy":"143.39","r":"9.06"}}),_c('circle',{staticClass:"cls-3",attrs:{"cx":"112.76","cy":"143.39","r":"9.06","transform":"rotate(-42.43 112.772 143.392)"}}),_c('path',{attrs:{"d":"M191.94 115.11c0-8.92-8.89-16.15-19.86-16.15s-19.86 7.23-19.86 16.15c0 7.23 4.1 15.75 13.63 22.05 0 0 4.73 2.74 3.25-2.14 0 0-1.36-3.39 4.92-3.85h.28a22.38 22.38 0 008.58-2.3c5.8-2.87 9.06-7.87 9.06-13.76z","fill":"#ff5b4f"}})])
          )
        }
      }
    